"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentThrow = void 0;
/**
 * Throws an error to break local development.
 * Use this to prevent things that shouldn't be done,
 * but you don't want to cause possible issues on development.
 */
const developmentThrow = (message = 'A message was not provided') => {
    // eslint-disable-next-line functional/no-conditional-statement
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line functional/no-throw-statement
        throw new Error(message);
    }
};
exports.developmentThrow = developmentThrow;
//# sourceMappingURL=developmentThrow.js.map